import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useLanguage } from '@/contexts/LanguageContext';
import { t } from '@/lib/translations';
import NoIndex from '@/components/seo/NoIndex';

/**
 * 404-Seite.
 *
 * SEO-Hinweis: Das Hosting liefert für SPA-Pfade immer HTTP 200 aus, ein echter
 * serverseitiger 404-Statuscode ist projektseitig nicht konfigurierbar. Deshalb
 * wird hier zwingend noindex,nofollow gesetzt, damit unbekannte Adressen nicht
 * als Kopie der Startseite indexiert werden.
 */
const NotFound = () => {
  const location = useLocation();
  const { language } = useLanguage();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-[calc(100vh-120px)] items-center justify-center premium-bg-glow">
      <NoIndex />
      <div className="text-center relative z-10">
        <h1 className="mb-4 text-6xl font-bold text-primary">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">{t('common', 'pageNotFound', language)}</p>
        <a href="/startseite" className="text-primary underline hover:text-primary/90">
          {t('common', 'backToStart', language)}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
